const COMPLETED_STATUSES = new Set(['completed', 'concluida']);
const CANCELLED_STATUSES = new Set(['cancelled', 'cancelada']);
const APPROVAL_STATUSES = new Set(['awaiting', 'aguardando_aprovacao']);
const SCHEDULED_STATUSES = new Set(['scheduled', 'rascunho', 'planejada']);

function validDate(value) {
  if (!value) return null;
  const date = value instanceof Date ? value : new Date(value);
  return Number.isNaN(date.getTime()) ? null : date;
}

function startOfLocalDay(value) {
  const date = validDate(value);
  if (!date) return null;
  return new Date(date.getFullYear(), date.getMonth(), date.getDate());
}

export function classifyFieldTask(task = {}, now = new Date()) {
  const status = String(task.status || task.databaseStatus || '').toLowerCase();
  if (COMPLETED_STATUSES.has(status)) return 'completed';
  if (CANCELLED_STATUSES.has(status)) return 'cancelled';
  if (APPROVAL_STATUSES.has(status)) return 'approval';
  if (status === 'late') return 'late';

  const plannedAt = validDate(task.plannedAt || task.inicio_previsto || task.dueAt);
  if (!plannedAt) return 'upcoming';
  const today = startOfLocalDay(now);
  const plannedDay = startOfLocalDay(plannedAt);

  if (SCHEDULED_STATUSES.has(status) && plannedAt.getTime() < now.getTime() && plannedDay < today) {
    return 'late';
  }
  if (plannedDay.getTime() === today.getTime()) return 'today';
  return 'upcoming';
}

export function summarizeFieldTasks(tasks = [], now = new Date()) {
  const summary = {
    today: 0,
    late: 0,
    approval: 0,
    completed: 0,
    cancelled: 0,
    upcoming: 0,
    actionable: 0,
  };

  tasks.forEach(task => {
    const bucket = classifyFieldTask(task, now);
    summary[bucket] += 1;
  });
  summary.actionable = summary.today + summary.late + summary.approval;
  return summary;
}
